import moment from 'moment';

const states = {
    feedback_details: {
        feedbacks: [],
        active_feedback_data: {
            messages: [],
            active_feedback_item:{}
        },
        filters: {
            date_range: [moment(new Date(), "DD-MM-YYYY").subtract(1, 'days'), moment(new Date(), "DD-MM-YYYY")],
        },
        loaders: {
            feedback_loading: false,
            feedback_loaded: false,
        }
    },
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/feedback_details/states.js